import {Link} from 'react-router-dom'
import {useAuth} from '../auth/AuthContext'
import {useLocale} from '../../shared/i18n/LocaleContext'
import type {CommercialRecord} from './commercialApi'
import type {TranslationKey} from '../../shared/i18n/translations'

export function DocumentTemplateDesigner(_props:{module:'sales'|'purchasing';templates:CommercialRecord[];kinds:{value:string;label:string}[];reload:()=>Promise<void>;onError:(message:string)=>void}){
 const{user}=useAuth();const{t}=useLocale();return <div className="document-designer document-designer-entry">{user?.capabilities.administration&&<><p>{t('documentDesigner.moduleSubtitle' as TranslationKey)}</p><Link className="primary-button" to="/app/disenador-documentos">{t('documentDesigner.moduleTitle' as TranslationKey)}</Link></>}</div>
}
